import * as React from 'react';

import Megaphone140 from './Megaphone140';

export const megaphone140 = () => <Megaphone140 />;

export default {
    title: 'Illustration|Megaphone140',
    component: Megaphone140,
    parameters: {
        notes: "`import Megaphone140 from 'box-ui-elements/es/illustration/Megaphone140';`",
    },
};
